var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucessModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 53.6663C12.2722 53.6663 0.333496 41.7277 0.333496 26.9997C0.333496 12.2717 12.2722 0.333008 27.0002 0.333008C41.7282 0.333008 53.6668 12.2717 53.6668 26.9997C53.6668 41.7277 41.7282 53.6663 27.0002 53.6663ZM24.3415 37.6663L43.1948 18.8103L39.4242 15.0397L24.3415 30.125L16.7975 22.581L13.0268 26.3517L24.3415 37.6663Z",
    fill: "#00C951"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucessModal);
export default __webpack_public_path__ + "static/media/sucessModal.01d6a90ca1b2ae0a3568dd223c319864.svg";
export { ForwardRef as ReactComponent };